import { InitPage } from "../index";

declare var $: any;

class SuperAdminAuth {
    private modal: any;
    private pending: any = null;
    private request: any = null;

    init() {
        this.modal = $(".int-auth#loginModal");
        if (!this.modal.length) return;

        $(document).on("click", ".retrieve-qty-cb", (e: any) => {
            e.preventDefault();
            e.stopPropagation();
            this.open($(e.currentTarget));
        });
        this.modal.on("click", "#toggle-password", () => {
            this.setShown(this.input().attr("type") === "password");
            this.input().trigger("focus");
        });
        this.modal.on("input", "#int-auth-password", () => {
            if (this.field().hasClass("err")) this.setError(null);
        });
        this.modal.on("submit", "#loginForm", (e: any) => {
            e.preventDefault();
            this.submit();
        });
        this.modal.on("shown.bs.modal", () => this.input().trigger("focus"));
        this.modal.on("hide.bs.modal", () => {
            if (this.request) this.request.abort();
        });
        this.modal.on("hidden.bs.modal", () => {
            this.reset();
            this.pending = null;
            if ($("#editIntegration").hasClass("in")) $("body").addClass("modal-open");
        });
    }

    input() {
        return this.modal.find("#int-auth-password");
    }

    field() {
        return this.modal.find(".int-auth-field");
    }

    open(checkbox: any) {
        this.pending = checkbox;
        const lead = this.modal.find("#int-auth-text");
        const action = String(checkbox.data("action-name") || "");
        if (action) {
            const [before, after] = String(lead.data("action-template")).split("%{action}");
            lead.empty().append(document.createTextNode(before), $("<b>").text(action), document.createTextNode(after || ""));
        } else {
            lead.text(String(lead.data("generic")));
        }
        this.reset();
        this.modal.modal("show");
    }

    reset() {
        this.setBusy(false);
        this.setError(null);
        this.setShown(false);
        this.input().val("");
    }

    setShown(shown: boolean) {
        const eye = this.modal.find("#toggle-password");
        this.input().attr("type", shown ? "text" : "password");
        eye.toggleClass("shown", shown)
            .attr("aria-pressed", String(shown))
            .attr("aria-label", eye.data(shown ? "hide-label" : "show-label"));
    }

    setError(key: string | null) {
        const hint = this.modal.find("#int-auth-hint");
        this.field().toggleClass("err", !!key);
        this.input().attr("aria-invalid", key ? "true" : "false");
        hint.toggleClass("error", !!key).attr("role", key ? "alert" : null);
        hint.find(".int-auth-hint-text").text(hint.data(key || "hint"));
    }

    setBusy(busy: boolean) {
        const button = this.modal.find("#authenticate");
        button.prop("disabled", busy).toggleClass("busy", busy);
        button.find(".int-auth-label").text(button.data(busy ? "checking-label" : "label"));
    }

    shake() {
        const field = this.field();
        field.removeClass("shake");
        void field[0].offsetWidth;
        field.addClass("shake");
        this.input().trigger("select");
    }

    submit() {
        const checkbox = this.pending;
        const password = String(this.input().val() || "");
        if (!checkbox || this.modal.find("#authenticate").prop("disabled")) return;
        if (!password) {
            this.setError("empty");
            this.input().trigger("focus");
            return;
        }

        this.setError(null);
        this.setBusy(true);
        this.request = $.ajax({
            method: "POST",
            dataType: "json",
            url: checkbox.data("url"),
            headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") },
            data: { password }
        })
            .done((result: any) => {
                if (result && result.status === true) {
                    checkbox.prop("checked", !checkbox.prop("checked")).trigger("change");
                    this.modal.modal("hide");
                } else {
                    this.setError("wrong");
                    this.shake();
                }
            })
            .fail((xhr: any) => {
                if (xhr.statusText !== "abort") this.setError("failed");
            })
            .always(() => {
                this.request = null;
                this.setBusy(false);
            });
    }
}

export function LoadPage() {
    InitPage("integrations", () => {
        new SuperAdminAuth().init();
    });
}
